module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tasksNotification":"You have {{ tasksCount }} tasks assigned","language":"Language"},"et":{"tasksNotification":"You have {{ tasksCount }} tasks assigned","language":"Language"},"ru":{"tasksNotification":"You have {{ tasksCount }} tasks assigned","language":"Language"}}')
  delete Component.options._Ctor
}
